module.exports = __webpack_public_path__ + "media/bootstrap-icons/journal-richtext-7ed4da1b.svg";